(function() { window.GUID_13f6ea7f_911a_4a1c_90f7_8bc207815a10 = { getGuid: function() { return "13f6ea7f-911a-4a1c-90f7-8bc207815a10"; } }; })();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class SquareCreditCard extends Controls.CreditCard {
            loadScript() {
                let me = this;
                let url = CS.CommonData.Current.IsDebug() ? "https://sandbox.web.squarecdn.com/v1/square.js" : "https://web.squarecdn.com/v1/square.js";
                if (typeof (Square) != "undefined") {
                    loadSquare(me);
                }
                else {
                    $.getScript(url, () => __awaiter(this, void 0, void 0, function* () {
                        yield loadSquare(me);
                    }));
                }
                function loadSquare(me) {
                    return __awaiter(this, void 0, void 0, function* () {
                        const payments = Square.payments(me.publicKey, me.publicKey2);
                        me.card = yield payments.card();
                        yield me.card.attach('.new-card');
                    });
                }
            }
            OnDispose() {
                super.OnDispose();
            }
            onMakePaymentNewCard(useNewCardCallback) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        const result = yield this.card.tokenize();
                        if (result.status === 'OK') {
                            console.log(`Payment token is ${result.token}`);
                            if (this.$Control.triggerHandler("paymentRequest") == false) {
                                event.preventDefault();
                            }
                        }
                        useNewCardCallback(result);
                    }
                    catch (e) {
                        console.error(e);
                    }
                });
            }
        }
        Controls.SquareCreditCard = SquareCreditCard;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=square-credit-card.js.map
